<template>
  <div>
    <v-container style="padding-top: 70px; min-height: calc(100vh - 350px);" class="pb-8">
      <v-row align="center">
        <v-col cols="4">
          <v-breadcrumbs :items="items" divider="|" class="px-0"></v-breadcrumbs>
        </v-col>
        <v-col cols="4" class="text-center">
          <h1 class="titulo" style="letter-spacing:1px;">MI CUENTA</h1>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="auto">
          <router-link to="/mi-cuenta/pedidos" class="menu-item-mi-cuenta">MIS PEDIDOS</router-link>
        </v-col>
        <v-col cols="auto" class="px-6">
          <router-link to="/mi-cuenta" class="menu-item-mi-cuenta">MIS DATOS</router-link>
        </v-col>
        <v-col cols="auto">
          <span class="menu-item-mi-cuenta d-inline-block" style="height: 18px;" @click="logout">
                        CERRAR SESIÓN
                    </span>
        </v-col>
      </v-row>

      <template v-if="pedidos.length > 0">
      
        <div v-for="(pedido,p) in pedidos" :key="'pedidos'+p">
          <v-row>
            <v-col cols="2">
              <span class="modernist-bold" style="color: #03241D; font-size: 12px;">NÚM. DE ORDEN</span>
            </v-col>
            <v-col cols="4">
              <span class="modernist-bold" style="color: #03241D; font-size: 12px;">DESCRIPCIÓN</span>
            </v-col>
            <v-col cols="2">
              <span class="modernist-bold" style="color: #03241D; font-size: 12px;">CANTIDAD</span>
            </v-col>
            <v-col cols="2">
              <span class="modernist-bold" style="color: #03241D; font-size: 12px;">PRECIO UNITARIO</span>
            </v-col>
            <v-col cols="2">
              <span class="modernist-bold" style="color: #03241D; font-size: 12px;">FECHA</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <v-row v-for="(item,i) in pedido.Items" :key="'item'+i">
            <v-col cols="2">
              <template v-if="i==0">{{pedido.id}}</template>
            </v-col>
            <v-col cols="4">
              <span
                class="d-inline-block modernist-bold uppercase"
                style="font-size: 12px; color: #03241D;"
              >{{item.NombreProducto}}</span>
              <span
                class="d-inline-block ml-3 modernist-bold uppercase"
                style="font-size: 12px; color: #979797; letter-spacing: 2px;"
              >{{item.NombreCientifico}}</span>
              <div>
                <template v-if="item.Maceta != ''">
                  <b>Maceta:</b>
                  <span class="d-inline-block mx-2">{{item.Maceta}}</span>
                </template>
                <template v-if="item.Base != ''">
                  <b>Base:</b>
                  <span class="d-inline-block mx-2">{{item.Base}}</span>
                </template>
              </div>
            </v-col>
            <v-col cols="2">
              <span class="modernist-bold verde-oscuro">{{item.Cantidad}}</span>
            </v-col>
            <v-col cols="2">
              <span class="modernist-bold verde-oscuro">${{item.Precio}} MXN</span>
            </v-col>
            <v-col cols="2">
              <template v-if="i == 0">
                <span class="modernist-bold verde-oscuro">{{pedido.created_at}}</span>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" class="text-right">
              <span class="modernist-bold" style="font-size: 16px; color: #03241D;">TOTAL</span>
            </v-col>
            <v-col cols="1" class="text-right">
              <span class="modernist" style="font-size: 16px;color:#03241D;">{{pedido.Total}} MXN</span>
              <span class="modernist d-block">IVA INCLUIDO</span>
              <span class="modernist d-block">COSTO DE ENVIO INCLUIDO</span>
            </v-col>
          </v-row>
        </div>

      </template>
      <template v-else>
        <v-row align="center" style="height: calc(100vh - 350px - 81px - 43px - 70px);">
          <v-col cols="12" class="text-center">
            <span class="modernist-bold" style="color: #03241D; font-size: 25px;">
              Aún no hay pedidos
            </span>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
import axios from "axios";
Vue.use(VueSession, { persist: true });
export default {
  data: () => ({
    pedidos: [],
    items: [
      {
        text: "Inicio",
        disabled: false,
        to: "/"
      },
      {
        text: "Mi cuenta",
        disabled: false,
        to: "/mi-cuenta"
      },
      {
        text: "Mis pedidos",
        disabled: true
      }
    ]
  }),
  created: function() {
    axios
      .get(
        "https://strapi.actstudio.xyz/pedidos?CorreoElectronico=" +
          this.$session.get("user").user.email,
        {
          headers: {
            Authorization: `Bearer ${this.$session.get("user").jwt}`
          }
        }
      )
      .then(response => {
        this.pedidos = response.data;
      })
      .catch(error => {});
  },
  methods: {
    logout: function() {
      this.$session.clear();
      this.$router.push("/");
    }
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Pedidos',
      'page_path': '/mi-cuenta/pedidos'
    });
  }
};
</script>